import { render, staticRenderFns } from "./reenrollment-alert.vue?vue&type=template&id=03e8cccf&"
import script from "./reenrollment-alert.vue?vue&type=script&lang=js&"
export * from "./reenrollment-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports